<template>
    <div class="cabinet">
        <div class="line pc-hide"></div>

        <div class="panel">
            <player_intro/>
            <div class="line pc-only"></div>
            <navigation class="pc-only"/>
        </div>
        <div class="content tmp-block-short">
            <keep-alive>
                <router-view/>
            </keep-alive>
        </div>
    </div>
</template>

<script>
    import player_intro from '@/components/cabinet/panel/player_intro.vue'
    import navigation from '@/components/cabinet/panel/cabinet_navigation.vue'
    import {mapGetters} from "vuex";
    export default {
        name: "Cabinet",
        components:{
            player_intro,
            navigation,
        },
        computed:{
            ...mapGetters('window', ['pcVersion'])
        }
    }
</script>

<style scoped lang="scss">
    .cabinet{
        display: grid;
        grid-template-columns: 272px 1fr;
        grid-gap: $spacing;

        .panel .line{
            width: 70%;
            margin: 24px 0;
        }
        @include laptop{
            display: flex;
            flex-direction: column;
            .panel{
                background-color: $bg_light;
                padding: 12px 32px;
                display: flex;
                align-items: center;
                margin-bottom: 16px;

                .line{
                    display: none;
                }
            }
        }
        @include tablet{
            .panel{
                padding: 24px;
                margin-bottom: 0;
                background: none;
            }
            .content{
                border-radius: 32px;
            }
        }
    }
</style>